import useSWRImmutable from "swr/immutable";
import { useSelector } from "react-redux";
import { useQuery } from "../../utility/useQuery";
import { getEventIdFromHref } from "../../utility/";
import { Store } from "../../store";
import { FeatureFlag, getFeatureFlag } from "../../constants/featureFlags";

const getNewPlayerFeatureFlag = async (): Promise<FeatureFlag | undefined> => {
  return await getFeatureFlag("newPlayer");
};

export const useEventIdFromUrl = (): string | undefined => {
  const query = useQuery();
  const location = useSelector((state: Store) => state.router.location);

  // ref: https://github.com/balus-co-ltd/spwn/blob/a348fe6b6b4ae8f8c0a04b777a39aedec7c470a0/legacy/packages/portal/src/features/crew/useCrewStreaming.tsx#L47
  const crewStreamingEventId = query.get("eventId");
  // ref: https://github.com/balus-co-ltd/spwn/blob/a348fe6b6b4ae8f8c0a04b777a39aedec7c470a0/legacy/packages/portal/src/containers/event/EventBase.tsx#L25-L26
  const eventPageEventId = getEventIdFromHref(location.pathname, "events");

  console.debug({
    crewStreamingEventId,
    eventPageEventId,
  });

  if (crewStreamingEventId) {
    return crewStreamingEventId;
  }
  if (eventPageEventId) {
    return eventPageEventId;
  }
  return undefined;
};

export const useEnableNewPlayer = (
  eventId: string | undefined
): boolean | undefined => {
  const { data: newPlayerFeatureFlag } = useSWRImmutable<FeatureFlag>(
    "getNewPlayerFeatureFlag",
    async () => {
      let flag: FeatureFlag | undefined;
      try {
        flag = await getNewPlayerFeatureFlag();
        console.debug({ flag });
      } catch (error) {
        console.debug("Failed to fetch new player feature flag:", error);
        return {
          globalEnabled: false,
          events: {},
        };
      }
      if (flag === undefined) {
        console.debug("Feature flag is undefined, returning default");
        return {
          globalEnabled: false,
          events: {},
        };
      }
      return flag;
    }
  );

  try {
    // From URL parameters
    const params = new URLSearchParams(window.location.search);
    if (params.get("useNewPlayer") === "1") {
      return true;
    }

    if (params.get("useOldPlayer") === "1") {
      return false;
    }

    // loading
    if (newPlayerFeatureFlag === undefined) {
      return undefined;
    }

    // From Firestore
    if (newPlayerFeatureFlag.globalEnabled) {
      return true;
    }
    if (eventId && newPlayerFeatureFlag.events[eventId]) {
      return true;
    }

    // Default to false
    return false;
  } catch (error) {
    return false;
  }
};
